import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { PROGRAM_ADS } from '../constants/state'
import ItemMovieAccess from './ItemMovieAccess'
import { ItemHeaderAccess, ItemTextAccess, ItemWrapperAccess } from './ItemHelpersAccess'

const mapStateToProps = (state, ownProps) => ({
    item: getData(state, [PROGRAM_ADS, ownProps.id]),
})

const ItemAdAccess = ({
    htmlId,
    item,
    filterType,
    filterValue
}) => {
    const { title, text, movieRefID, link } = item 
    const hasLinkUrl = link && link.url

    if(movieRefID && !hasLinkUrl) {
        return (
            <ItemMovieAccess
                htmlId={htmlId}
                id={movieRefID}
                optionalTitle = {title}
                optionalDescription = {text}
                useMovieTitleAsSubtitle={false}
                useNoSubtitle={true}
                queryStringValues={null}
                filterType={filterType}
                filterValue={filterValue}
                overviewFilterIgnoreOnPerformances={null}
                dayFilters={null}
            />
        )
    } else {
        const hasLink = hasLinkUrl && link.text 

        return (
            <ItemWrapperAccess>
                <ItemHeaderAccess
                    title={title}
                />

                <ItemTextAccess
                    text={text}
                />

                {hasLink && <a href={link.url} target={'external' === link.destinationType ? '_blank'  : '_self'}>
                    {link.text}
                </a>}
            </ItemWrapperAccess>
        )
    }
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ItemAdAccess)